import { render, staticRenderFns } from "./MangheMadeOrder.vue?vue&type=template&id=0fe7dc7d&scoped=true&"
import script from "./MangheMadeOrder.vue?vue&type=script&lang=js&"
export * from "./MangheMadeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7dc7d",
  null
  
)

export default component.exports